<template>
  <article>
    <custom-callout
      v-for="currentStudent in studentList"
      :key="currentStudent.id"
      :has-toggle="true"
      class="mt-2 mb-3"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-6 col-md-2 mb-2 mb-md-0">
            <span class="box-result-field-label">{{ currentStudent.sie }}</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.name }}
            </span>
          </div>
          <div class="col-6 col-md-1 mb-1 mb-md-0">
            <span class="box-result-field-label">Edad:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.age }}
            </span>
          </div>
          <div class="col-6 col-md-1 mb-1 mb-md-0">
            <span class="box-result-field-label">Grado:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.gade }}
            </span>
          </div>
          <div class="col-6 col-md-3 mb-3 mb-md-0">
            <span class="box-result-field-label">Impedimento:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.impediment }}
            </span>
          </div>
          <div class="col-6 col-md-3 mb-3 mb-md-0">
            <span class="box-result-field-label">
              Alternativa de ubicacion:
            </span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.ubicationAlternative }}
            </span>
          </div>
          <div class="col-6 col-md-2 mt-1 mb-md-0 text-md-right">
            <ActionButton
              text="Eliminar"
              class="mb-1"
              variant="outline-danger"
              i="fas fa-times-circle"
              @click="deleteStudent(currentStudent.id, currentStudent.name)"
            />
          </div>
        </div>
      </div>
    </custom-callout>
  </article>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import alert from '@/mixin/alert.mixin';
import { deleteStudentToAssistant } from '@/modules/service-assitant/api';

export default {
  name: 'AssignedStudentRow',
  mixins: [alert],
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    studentList: {
      type: Array,
      require: true,
      default: () => {},
    },
  },
  mounted() {},
  methods: {
    async deleteStudent(id, name) {
      let response = await alert.methods.ShowConfirm(
        'Atención',
        `¿Está seguro que desea remover el estudiante ${name}?`
      );
      if (response) {
        deleteStudentToAssistant(id).then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Confirmación',
              'El estudiante ha sido removido exitosamente.',
              'success'
            );
            this.$emit(
              'remove',
              this.studentList.find((x) => x.id == id)
            );
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.box-result-field-value {
  font-weight: bold;
}
</style>
